import React from 'react';

import './Confirmed.css';


const Confirmed = ({
  completions,
}) => (
  <div className="reportConfirmed_main">
    <div className="reportConfirmed_container">
      <div className="reportConfirmed_text">
        Thank you for recording your actions!
        <br />
        { `You've completed ${completions}!` }
      </div>
    </div>
  </div>
);

export default Confirmed;



// WEBPACK FOOTER //
// ./src/views/Report/Confirmed.js